import { GridFilterCell } from '@progress/kendo-react-grid'
import React from 'react'

export class PercentageFilterCell extends GridFilterCell {
  onValueChange = (e) => {
    if (typeof e.value === 'number') {
      e.value = e.value / 100
    }
    this.props.onChange(e)
  }
  render () {
    const value = typeof this.props.value === 'number' ? this.props.value * 100 : this.props.value
    return (
      <GridFilterCell
        {...this.props}
        filterType={'numeric'}
        value={value}
        onChange={this.onValueChange} />
    )
  }
}

export function percentageCellExport ({ dataItem, field }) {
  return dataItem[field] && dataItem[field] * 100
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/percentageFilterCell.js